module.exports = __webpack_public_path__ + "static/media/allowed-status.b4fe44d2.svg";